import { AccessorsMutatorsDecorator, Model } from "../../helpers";

/**
 * @property {number} id
 */
export class PaymentGatewayApiLog extends Model {
}

AccessorsMutatorsDecorator(
    'id',
    'property_id',
    'transaction_id',
    'is_success',
    'requested_at',
    'request_body',
    'responded_at',
    'response_body'
)(PaymentGatewayApiLog);



// WEBPACK FOOTER //
// ./src/pms-api/models/payment-gateway-api-log.model.js